import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#f5c518' }, // Soyl yellow
    secondary: { main: '#00a8a8' }, // Teal (Water Saved)
    success: { main: '#00a878' }, // Green (Sustainability)
    info: { main: '#0096ff' }, // Blue (Carbon Credit)
    sidebar: { main: '#1a1a1a' }, // Dark gray
    background: { default: '#ffffff' },
    text: { primary: '#000000', secondary: '#909090', white: "#ffffff" },
    delta: { main: '#27AE60' }, // Green for deltas
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontSize: '24px', fontWeight: 700 },
    h5: { fontSize: '18px', fontWeight: 700 },
    h6: { fontSize: '16px', fontWeight: 700 },
    body1: { fontSize: '16px', fontWeight: 700 },
    body2: { fontSize: '14px' },
  },
  shape: { borderRadius: 2},
  components: {
    MuiPaper: { styleOverrides: { root: { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' } } },
    MuiChip: { styleOverrides: { root: { backgroundColor: '#27AE60', color: '#ffffff' } } },
  },
});

export default theme;